/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
import { KeyFrameAnimationTimeline } from "./KeyFrameAnimationTimeline";
import { KeyFrameAnimationDirect } from "./KeyFrameAnimationDirect";
import { AnimationBrowserTickProvider } from "./AnimationBrowserTickProvider";
import { DOMExecutionContext } from "./DOMExecutionContext";
/**
 * @hidden
 */
var KeyFrameAnimationFactory = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(KeyFrameAnimationFactory, _super);
    function KeyFrameAnimationFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.g = null;
        return _this;
    }
    Object.defineProperty(KeyFrameAnimationFactory, "f", {
        get: function () {
            if (KeyFrameAnimationFactory.e == null) {
                KeyFrameAnimationFactory.e = new PlatformKeyFrameAnimationFactory(KeyFrameAnimationFactory.h);
                KeyFrameAnimationFactory.e.g = new KeyFrameAnimationTimeline(KeyFrameAnimationFactory.e.d, KeyFrameAnimationFactory.e.b);
            }
            return KeyFrameAnimationFactory.e;
        },
        enumerable: true,
        configurable: true
    });
    KeyFrameAnimationFactory.prototype.c = function (a) {
        return new KeyFrameAnimationDirect(a, this.g);
    };
    KeyFrameAnimationFactory.$t = markType(KeyFrameAnimationFactory, 'KeyFrameAnimationFactory');
    KeyFrameAnimationFactory.e = null;
    KeyFrameAnimationFactory.h = null;
    return KeyFrameAnimationFactory;
}(Base));
export { KeyFrameAnimationFactory };
/**
 * @hidden
 */
var PlatformKeyFrameAnimationFactory = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PlatformKeyFrameAnimationFactory, _super);
    function PlatformKeyFrameAnimationFactory(a) {
        var _this = _super.call(this) || this;
        _this.j = null;
        _this.i = null;
        _this.j = new AnimationBrowserTickProvider(a);
        _this.i = new DOMExecutionContext(a);
        return _this;
    }
    PlatformKeyFrameAnimationFactory.prototype.get_d = function () {
        return this.j;
    };
    Object.defineProperty(PlatformKeyFrameAnimationFactory.prototype, "d", {
        get: function () {
            return this.get_d();
        },
        enumerable: true,
        configurable: true
    });
    PlatformKeyFrameAnimationFactory.prototype.get_b = function () {
        return this.i;
    };
    Object.defineProperty(PlatformKeyFrameAnimationFactory.prototype, "b", {
        get: function () {
            return this.get_b();
        },
        enumerable: true,
        configurable: true
    });
    PlatformKeyFrameAnimationFactory.$t = markType(PlatformKeyFrameAnimationFactory, 'PlatformKeyFrameAnimationFactory', KeyFrameAnimationFactory.$);
    return PlatformKeyFrameAnimationFactory;
}(KeyFrameAnimationFactory));
export { PlatformKeyFrameAnimationFactory };
//# sourceMappingURL=KeyFrameAnimationFactory_combined.js.map
